import {
  Button,
  Col,
  Flex,
  List,
  Modal,
  Progress,
  Row,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import React, { useEffect, useState } from "react";
import "./RecommendedProductType.css";
import { setIsProductPopUp } from "../../../store/slices/common-slice/product-details-action-items/productDetailsActionItemslice";
import { useDispatch } from "react-redux";
import ProductModalPopUp from "../product-detail-modal/ProductModalPopUp";

const RecommendedProductType = ({
  recommendedProductTypeModal,
  setRecommendedProductTypeModal,
  recommendedProductType,
}) => {
  const [selectedProduct, setSelectedProduct] = useState("");

  const { Text } = Typography;
  const capitalCase = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const dispatch = useDispatch();
  const sortedObj = Object.fromEntries(
    Object.entries(recommendedProductType?.feature_contributions || {}).sort(
      (a, b) => (b[1] ?? 0) - (a[1] ?? 0)
    )
  );
  useEffect(() => {
    setSelectedProduct(recommendedProductType?.id);
  }, [recommendedProductType?.id]);
  const handleOpenProductDetails = () => {
    dispatch(setIsProductPopUp(true));
  };

  return (
    <>
      <Modal
        title={
          <Text className="recommended-product-type-title">
            Why this product is recommended?
          </Text>
        }
        open={recommendedProductTypeModal}
        width={537}
        footer={false}
        onCancel={() => setRecommendedProductTypeModal(false)}
      >
        <div className="recommended-product-type-container">
          <p className="quick-summary-title">Quick summary</p>
          <Text className="overall-title">
            Overall Match Score:{" "}
            {recommendedProductType?.overall_similarity * 100 || 0}%
          </Text>
          <p className="top-strength-title">
            Top Strength: Location & Audience Reach
          </p>
          <p className="quick-summary-title">Similarity Breakdown</p>
          <List size="large" bordered>
            <div className="recommended-header">
              <List.Item>
                {" "}
                <Row justify={"space-between"}>
                  <Col>
                    <Text className="recommended-header-text">Feature</Text>
                  </Col>
                  <Col></Col>
                  <Col>
                    <Text className="recommended-header-text">Match% </Text>
                  </Col>
                </Row>
              </List.Item>
            </div>
            <div className="recommended-scrollable">
              {Object.entries(sortedObj || {}).map(([key, value]) => (
                <List.Item key={key}>
                  <Row justify="space-between" style={{ width: "100%" }}>
                    <Col span={8}>
                      <Text className="recommended-match-feature">
                        {capitalCase(key)}
                      </Text>
                    </Col>
                    <Col span={13}>
                      <Flex vertical gap="small" style={{ width: "90%" }}>
                        <Progress
                          percent={value * 100} // convert 0.87 → 87%
                          strokeColor={value > 0.5 ? "#008342" : "#FAA300"}
                          size="small"
                          showInfo={false}
                        />
                      </Flex>
                    </Col>
                    <Col span={3}>
                      <Text className="recommended-match-percentage">
                        {(value * 100).toFixed(0)}%
                      </Text>
                    </Col>
                  </Row>
                </List.Item>
              ))}
            </div>
            <List.Item></List.Item>
          </List>
          <Text className="recommended-match-feature">
            {recommendedProductType?.overall_similarity * 100 || 0}% match –
            Strong on location, audience reach, and size; other factors matter
            less.
          </Text>
        </div>{" "}
        <Row justify={"end"} style={{ marginTop: 20 }}>
          <Button className="cancel-products-btn">
            <Text
              className="cancel-products-btn-text"
              onClick={() => {
                setRecommendedProductTypeModal(false);
              }}
            >
              Cancel
            </Text>
          </Button>
          <Button
            className="add-campaign-btn"
            onClick={handleOpenProductDetails}
          >
            <Text className="add-campaign-btn-text">Add to Campaign</Text>
          </Button>
        </Row>
      </Modal>

      <ProductModalPopUp
        contentName={"Check Product Availability"}
        productId={selectedProduct}
        setSelectedProduct={setSelectedProduct}
        isCampaignsPage={true}
      />
    </>
  );
};

export default RecommendedProductType;
